export default __webpack_public_path__ + "static/media/xRekognition.47b72bbd.png";